import { createUuidV4 } from 'utils/createUuidV4';

export const createUniqueTransactionId = () => createUuidV4();
